import { openDB } from "idb";

const DB_NAME = "brawnyai-chess";
const SCHEMA_VERSION = 1;

export class SaveStore {
  #dbPromise;
  constructor() {
    this.#dbPromise = openDB(DB_NAME, SCHEMA_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains("state")) {
          db.createObjectStore("state");
        }
        if (!db.objectStoreNames.contains("history")) {
          db.createObjectStore("history", { keyPath: "id" });
        }
      },
    });
  }

  async loadActive() {
    try {
      const record = await (await this.#dbPromise).get("state", "active");
      if (!record) {
        return null;
      }
      if (
        record.schemaVersion !== SCHEMA_VERSION ||
        typeof record.pgn !== "string" ||
        record.pgn.length > 100_000
      ) {
        throw new Error("Incompatible save record");
      }
      return record;
    } catch (error) {
      console.warn("Ignoring corrupt save", error);
      return null;
    }
  }

  async saveActive(record) {
    const safe = {
      ...record,
      schemaVersion: SCHEMA_VERSION,
      updatedAt: new Date().toISOString(),
    };
    await (await this.#dbPromise).put("state", safe, "active");
  }

  async settings() {
    return (await (await this.#dbPromise).get("state", "settings")) ?? {};
  }
  async saveSettings(settings) {
    await (
      await this.#dbPromise
    ).put("state", structuredClone(settings), "settings");
  }

  async archive(record) {
    const db = await this.#dbPromise;
    await db.put("history", {
      ...record,
      id: crypto.randomUUID(),
      archivedAt: new Date().toISOString(),
    });
    const all = (await db.getAll("history")).sort((a, b) =>
      b.archivedAt.localeCompare(a.archivedAt),
    );
    for (const old of all.slice(20)) {
      await db.delete("history", old.id);
    }
  }

  async clear() {
    const db = await this.#dbPromise;
    await db.clear("state");
    await db.clear("history");
  }
}
